// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import store from './store'
import router from './router'

import 'bootstrap'
import '@/assets/css/bootstrap.min.css'
import moment from 'moment'
import VueBootstrapToasts from 'vue-bootstrap-toasts'
import VueHtmlToPaper from 'vue-html-to-paper'

Vue.use(VueBootstrapToasts)

const vueHtmlToPaperOptions = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.3.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}
Vue.use(VueHtmlToPaper, vueHtmlToPaperOptions)

Vue.config.productionTip = false

axios.defaults.baseURL = process.env.URLS_PUBLIC_API

let sessionKey = localStorage.getItem('session-key')
if (!sessionKey) {
  sessionKey = new Date().getTime()
  localStorage.setItem('session-key', sessionKey)
}
axios.defaults.headers.common['X-SESSION-KEY'] = sessionKey

const apiToken = localStorage.getItem('api-token')
if (apiToken) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + apiToken
}

const apiKey = localStorage.getItem('api-key')
if (apiKey) {
  axios.defaults.headers.common['X-API-KEY'] = apiKey
}

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('Do MMMM YYYY')
  }
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('MMMM Do YYYY, h:mm a')
  }
})

Vue.filter('numberToRs', function (amount, decimalCount = 2, decimal = '.', thousands = ',') {
  decimalCount = Math.abs(decimalCount)
  decimalCount = isNaN(decimalCount) ? 2 : decimalCount

  const negativeSign = amount < 0 ? '-' : ''

  let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
  let j = (i.length > 3) ? i.length % 3 : 0

  return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {App},
  template: '<App/>',
  created () {
    if (this.$store.getters.isAuthenticated) {
      let getUser = this.$store.dispatch('getUser').catch(error => {
        let errorMessage = 'Failed to get user information.'
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage += ' ' + error.response.data.message
        }
        let errorDescription = (error.response && error.response.data && error.response.data.description) || null

        this.$toast.error(errorMessage, errorDescription)
      })

      getUser.then(() => {
        if (this.$store.getters.hasApiKey) {
          this.$store.dispatch('getStore').catch(error => {
            let errorMessage = 'Failed to get store information.'
            if (error.response && error.response.data && error.response.data.message) {
              errorMessage += ' ' + error.response.data.message
            }
            let errorDescription = (error.response && error.response.data && error.response.data.description) || null

            this.$toast.error(errorMessage, errorDescription)

            this.$router.push({ name: 'stores' })
          }).then(() => {
            this.$store.dispatch('getPosSettings')
          })
        }
      })
    }
  },
  watch: {
    '$route': {
      handler: (to, from) => {
        document.title = (to.meta.title ? to.meta.title + ' - ' : '') + process.env.APP_NAME
      },
      immediate: true
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js